import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';
import { generateChildIssuesJQL } from '../../../../common/utils/generate-child-issues-jql/index.tsx';
import type { ChildIssuesPanelType, SortOption } from '../../../../common/types.tsx';

export const triggerButtonTestId =
	'issue.views.common.child-issues-panel.heading.meatballs.dropdown.trigger-button';

const BULK_EDIT_URL = '/secure/views/bulkedit/BulkEdit1!default.jspa?reset=true&new=true';

export const generateBulkEditLink = (
	parentKey: IssueKey,
	childIssuesPanelType: ChildIssuesPanelType,
	hasExceededIssuesLimitInitialLoad: boolean,
	sortByValue?: SortOption,
) =>
	`${BULK_EDIT_URL}&${generateChildIssuesJQL(
		parentKey,
		childIssuesPanelType,
		hasExceededIssuesLimitInitialLoad,
		sortByValue,
	)}`;
